import { get, post } from "../utility/fetch-util";

export const getMaintenanceRequests = async (vehicleId, customFromDate, customToDate, progress) => {
    return get('/api/drivers/maintenance/' + vehicleId + '/' + customFromDate + '/' + customToDate + '/requests', null, progress);
}

/**
 * Submit driver request for maintenance work to be undertaken
 */
export const submitMaintenanceRequest = async (vehicleId, request, progress) => {
    return post('/api/drivers/maintenance/' + vehicleId + '/saverequest', null, request, progress);
}

export const getMaintenanceRecalls = async (vehicleId, progress) => {
    return get('/api/drivers/maintenance/' + vehicleId  + '/recalls', null, progress);
}

export const getMaintenanceServices = async (vehicleId, includeCompletedOrSkipped = false, progress) => {
    return get('/api/drivers/maintenance/' + vehicleId + '/' + includeCompletedOrSkipped  + '/services', null, progress);
}

export const getHistory = async (vehicleId, progress) => {
    return get('/api/drivers/maintenance/' + vehicleId  + '/history', null, progress);
}

export const getJobsAwaitingDriverReview = async (vehicleId, progress) => {
    return get('/api/drivers/maintenance/' + vehicleId  + '/jobs/pending-review', null, progress);
}

/**
 * This list of statuses ensures UI and backoffice in sync, no hard-coding of statuses. 
 * This list is utilized during the driver review of a maintenance job process.
 */
export const getJobItemStatuses = async (progress) => {
    return get('/api/drivers/maintenance/jobitem-statuses', null, progress);
}

/**
 * Submit driver review for a job
 */
export const submitDriverReview = async (vehicleId, job, progress) => {
    return post('/api/drivers/maintenance/' + vehicleId + '/job-review/submit', null, job, progress);
}

/**
 * Determine if a job review request has been overrridden by the backoffice analyst
 */
export const getJobReviewRequestOverridden = async (jobId, progress) => {
    return get('/api/drivers/maintenance/' + jobId  + '/job-review/overridden', null, progress);
}

/**
 * Get the details of a booking 
 */
export const getBooking = async (bookingId, progress) => {
    return get('/api/drivers/maintenance/booking/' + bookingId, null, progress);
}

/**
 * Get the details of a work request 
 */
export const getWorkRequest = async (workRequestId, progress) => {
    return get('/api/drivers/maintenance/workrequest/' + workRequestId, null, progress);
}

/**
 *  Get maintenance company group customer specific tyre instruction
 */
export const getTyreConfiguration = async (entityId, type, customerCode, progress) => {
    return get('/api/drivers/tyre/customer/entity/' + entityId + '/type/' + type + '/code/' + customerCode, null, progress);
}